import type { CmpHider } from './types';

export const securePrivacy: CmpHider = {
  id: 'secure-privacy',
  label: 'Secure Privacy',
  css: `
      /* Secure Privacy (secureprivacy.ai CMP): the consent UI is injected
         directly onto <body> as a set of "sp-"-namespaced pieces. The visible
         bottom consent banner is a fixed, full-width iframe "#ifrmCookieBanner"
         (position:fixed, z-index 2147483647) wrapped in a "#main-cookie-banner"
         root container; hiding both removes the banner. After a choice is made
         (and on later visits) the platform leaves a persistent fixed floating
         "Trust badge" cog widget "#sp-widget" (.sp-widget, z-index 2147483647)
         over the page — hide it too. The preferences modal renders in a fixed
         "#sp-preference-center" (.sp-preference-center, z-index 2147483647) that
         dims the page; hide it so an opened modal leaves no faded backdrop. The
         "sp-"/"#main-cookie-banner"/"#ifrmCookieBanner" hooks are specific to the
         Secure Privacy consent UI, so this does not touch unrelated page content
         (e.g. a page section with id "consent"/"tab-consent"). Secure Privacy does
         not lock page scroll via a body class or inline style on the sites
         observed; if a build does, the html/html-body [style*="overflow"] and
         [style*="position: fixed"] release rules above already out-specify an
         inline overflow/position lock. */
      #main-cookie-banner,
      #ifrmCookieBanner,
      #sp-widget,
      .sp-widget,
      #sp-preference-center,
      .sp-preference-center { display: none !important; }
  `,
};
